import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Name",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "description",
		headerName: "Description",
		minWidth: 350,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "code",
		headerName: "Code",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "colorCode",
		headerName: "Color Code",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		renderCell(params) {
			return (
				<div 
					className={`w-[80px] h-[30px] border-[0.5px] bg-[${params.value}]`} 
					style={{ backgroundColor: params.value }} 
				/>
			);
		},
	},
	
	...createdAtmodifiedAtActions
];
